/**
 * Created by Jerker Nord on 2023-06-10.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../Loner";
import {gsap} from "gsap";
import {LonerGameMode} from "../../server/LonerGameMode";

export class LonerMaxWinPresentation implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        return Loner.model.brokeBank;
    }

    public start(controller:SimplePresentationRunnerController):void {
        controller.setSkipCallback();

        this._controller = controller;
        this._mainTL = gsap.timeline();
        if(Loner.model.data.mode == LonerGameMode.NORMAL) {
            this._mainTL.add(Loner.mainGameMaxWinView.getMaxWinTL(() => this.complete()));
        } else if(Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
            this._mainTL.add(Loner.ssdMaxWinView.getMaxWinTL(() => this.complete()));
        } else if(Loner.model.data.mode == LonerGameMode.FEATURE_PIN_THE_WIN) {
            this._mainTL.add(Loner.pinTheWinMaxWinView.getMaxWinTL(() => this.complete()));
        }
    }

    private complete():void {
        if(Loner.model.data.mode == LonerGameMode.NORMAL) {
            Loner.mainGameMaxWinView.endMaxWin();
        } else if(Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
            Loner.ssdMaxWinView.endMaxWin();
        } else if(Loner.model.data.mode == LonerGameMode.FEATURE_PIN_THE_WIN) {
            Loner.pinTheWinMaxWinView.endMaxWin();
        }
        this._controller.finish();
    }
}